import initDropDownsProgramsOnline from "./online/dropDownPrograms";
import initDropDownsProgramsOffline from "./offline/dropDownPrograms";
import netRequestsOnline from "./online/netRequests";
import netRequestsOffline from "./offline/netRequests";
import shortForm from "./shortForm";
import unlockProgramField from "./unlock-program-field";
import datepicker from "./datepicker";
import form from "./form";
import select from "./select";

const initForm = () => {
  const TrainingFormat = document.getElementById("TrainingFormat");
  const TrainingFormatModal = document.getElementById("TrainingFormat-modal");
  const Program = document.getElementById(`Program`);
  const ProgramModal = document.getElementById(`Program-modal`);
  const url = location.href.split("/");

  /* Получение списка доступных программ для редиректа и передача в инициализацию поля "Программа обучения" */
  async function initNetRequests() {
    const allProgramsOffline = await netRequestsOffline();
    const allProgramsOnline = await netRequestsOnline();

    /* Логика на поле "Формат обучения" */
    choiceTrainingFormat(TrainingFormat, "");
    choiceTrainingFormat(TrainingFormatModal, "-modal");

    /* Логика по выводу программ в укороченной форме */
    shortForm(allProgramsOnline, allProgramsOffline);

    function choiceTrainingFormat(FORMAT, pref) {
      if (url.includes("program")) {
        const TrainingFormatValue = document.getElementById(
          `TrainingFormatHidden${pref}`
        );

        if (TrainingFormatValue) {
          logicFieldTrainingFormat(Program, pref, TrainingFormatValue.value);
        }
      } else {
        if (FORMAT !== null) {
          FORMAT.onchange = function (e) {
            logicFieldTrainingFormat(ProgramModal, pref, e.target.value);
          };
        }
      }
    }

    function logicFieldTrainingFormat(PROGRAM, pref, status) {
      const block = document.getElementById(`hiddenBlockForm${pref}`);
      const City = document.getElementById(`City${pref}`);
      const Direction = document.getElementById(`Direction${pref}`);
      const required = City.parentElement.querySelector(".city-required");
      let requiredDirection;
      if (Direction) {
        requiredDirection = Direction.parentElement?.querySelector(
          ".direction-required"
        );
      }

      $(`#Category${pref}`).val("").trigger("change");
      $(`#Education${pref}`).val("").trigger("change");

      block.style.display = "block";

      if (PROGRAM) {
        [...PROGRAM.children].map((item, idx) => {
          if (idx > 0) {
            item.remove();
          }
        });
      }

      if (status === "online") {
        initDropDownsProgramsOnline(`${pref}`, allProgramsOnline);

        City.parentElement.style.display = "none";

        if (Direction) {
          Direction.parentElement.style.display = "block";
          requiredDirection?.classList.add("form-required");
        }
        if (required.classList.contains("form-required")) {
          required.classList.remove("form-required");
        }
      } else {
        initDropDownsProgramsOffline(`${pref}`, allProgramsOffline);

        City.parentElement.style.display = "block";
        required.classList.add("form-required");

        if (Direction) {
          Direction.parentElement.style.display = "none";

          if (requiredDirection.classList.contains("form-required")) {
            requiredDirection.classList.remove("form-required");
          }
        }
      }

      /* Разблокирование поля "Программы обучения" после получения списка программ */
      unlockProgramField();
    }
  }

  datepicker();
  select();
  initNetRequests();
  form();
};

export default initForm;
